import * as ReportsActions from 'client/features/reports/actions'
import _ from 'underscore'

const initialState = {
    all: [],
    current: null,
    filters: {},
    search: null
}

const initializeState = () => Object.assign({}, initialState)

export default function reports(state = initializeState(), action = {}) {
    switch (action.type) {

    case ReportsActions.ReportsRequest.get.TYPES.SUCCESS:
        return { ...state, all: action.payload.reports }

    case ReportsActions.REPORTS_FILTERS_CHANGE:
        return { ...state, filters: action.payload.filters }
    
    case ReportsActions.REPORTS_SEARCH_CHANGE:
        return { ...state, search: action.payload.search }

    case ReportsActions.SOCKET_NEW_REPORT:
        return { ...state, all: [...state.all, action.payload.report]}

    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/reports/reducers.js